import React from 'react';
import PropTypes from 'prop-types';
import Downshift from 'downshift';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';

const renderInput = (inputProps) => {
  const { InputProps, classes, ref, unAuthorized, fieldLabel, value, ...other } = inputProps;

  return (
    <TextField
      margin="normal"
      label={value ? value : fieldLabel}
      disabled={unAuthorized}
      InputProps={{
        inputRef: ref,
        classes: {
          root: classes.textField,
        },
        ...InputProps,
      }}
      {...other}
    />
  );
};

const styles = theme => ({
  container: {
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 300,
  },
});

function renderSuggestion({ suggestion, index, itemProps, highlightedIndex, selectedItem, dataKey }) {
  const isHighlighted = highlightedIndex === index;
  // const isSelected = (selectedItem || '').indexOf(suggestion.label) > -1;
  const isSelected = (selectedItem || '').startsWith(suggestion.label);
  return (
    <MenuItem
      {...itemProps}
      key={suggestion[dataKey] + index}
      selected={isHighlighted}
      component="div"
      style={{
        fontWeight: isSelected ? 500 : 400,
      }}
    >
      {suggestion[dataKey]}
    </MenuItem>
  );
}
renderSuggestion.propTypes = {
  highlightedIndex: PropTypes.number,
  index: PropTypes.number,
  itemProps: PropTypes.object,
  selectedItem: PropTypes.string,
  suggestion: PropTypes.shape({ label: PropTypes.string }).isRequired,
};

function getSuggestions(inputValue, data, dataKey, suggestionCount) {
  let count = 0;

  return data.filter(dataSet => {
    // const keep = (!inputValue || dataSet[dataKey].toLowerCase().indexOf(inputValue.toLowerCase()) !== -1) && count < suggestionCount;
    // const keep = (!inputValue || dataSet[dataKey].toLowerCase().startsWith(inputValue.toLowerCase())) && count < suggestionCount;
    // const keep = (!inputValue || dataSet[dataKey].toLowerCase().includes(inputValue)) && count < suggestionCount;
    // console.log(dataSet[dataKey].toLowerCase().split(":"));
      const keyword = dataSet[dataKey].toLowerCase().split(":");
      const keep = (!inputValue || keyword[keyword.length - 1].includes(inputValue.toLowerCase()) || dataSet[dataKey].toLowerCase().startsWith(inputValue.toLowerCase())) && count < suggestionCount;
    if (keep) {
      count += 1;
    }

    return keep;
  });
}

const AutoComplete = (props) => {
  const { classes, unAuthorized, value, onItemSelect, data, dataKey, name, fieldLabel, suggestionCount = 15 } = props;
  return (
    <Downshift name={name} onChange={onItemSelect} style={{ height: 200 }} defaultValue={value} >
      {({ getInputProps, getItemProps, isOpen, inputValue, selectedItem, highlightedIndex }) => (
        <div classlabel={classes.container}>
          {renderInput({
            fullWidth: true,
            unAuthorized,
            classes,
            fieldLabel,
            value,
            InputProps: getInputProps({
              placeholder: value,
              id: 'integration-downshift-simple',
            }),
          })}
          {isOpen ? (
            <Paper style={{  maxHeight: 200, overflowY: 'scroll' }} square>
              {getSuggestions(inputValue, data, dataKey, suggestionCount).map((suggestion, index) =>
                renderSuggestion({
                  suggestion,
                  index,
                  dataKey,
                  itemProps: getItemProps({ item: suggestion[dataKey] }),
                  highlightedIndex,
                  selectedItem,
                }),
              )}
            </Paper>
          ) : null}
        </div>
      )}
    </Downshift>
  );
};

AutoComplete.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AutoComplete);



// WEBPACK FOOTER //
// ./src/components/shared/AutoComplete.js